import { render, staticRenderFns } from "./modalupload.vue?vue&type=template&id=322afd7f&scoped=true&"
var script = {}
import style0 from "./modalupload.vue?vue&type=style&index=0&id=322afd7f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322afd7f",
  null
  
)

export default component.exports